import React from "react";

/** Odontopick tooth mark (matches brand). */
export function ToothLogo({ className = "", size = 28, color = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M20 22c0-6 5-11 11-11 6 0 10 3 14 3h10c4 0 8-3 14-3 6 0 11 5 11 11 0 10-4 16-6 30-1.6 11-3 32-9 32-5 0-5-16-6-24-.4-3-2-5-4-5s-3.6 2-4 5c-1 8-1 24-6 24-6 0-7.4-21-9-32-2-14-6-20-6-30Z"
        fill={color}
      />
    </svg>
  );
}

export default ToothLogo;
